import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Classificação TACO',
  path: '/merenda/mertacoclassificacao',
  name: 'mertacoclassificacao',
  component: () => import('@/views/merenda/mertacoclassificacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.CLASSIFICACAOTACONOVO_MENU_1000600619],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Classificação TACO',
  path: '/merenda/mertacoclassificacao/cadastro/:id?',
  parent: 'mertacoclassificacao',
  name: 'mertacoclassificacao_create',
  component: () => import('@/views/merenda/mertacoclassificacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.CLASSIFICACAOTACONOVO_MENU_1000600619],
  },
  goesToMenu: true,
 },
]
